<template>
  <div>
    <div class="main">
      <div class="tipinfo">
        本操作用于将悦享工资条小程序集成到客户自己的公众号内，方便员工从企业公众号中查看工资条明细。
      </div>

      <div class="title">
        1.打开
        <a href="https://mp.weixin.qq.com" target="_blank">https://mp.weixin.qq.com</a>
        进入微信公众平台，使用公司公众号管理员的账号或者微信扫码登录。若企业尚无公众号，可先为企业申请公众号。
      </div>
      <div>
        <el-image :src="require('@/assets/wx/1.jpg')" :preview-src-list="srcList">
        </el-image>
        <!-- <img src="@/assets/wx/1.jpg" alt="" /> -->
      </div>
      <div class="title">
        2.进入公众号管理平台后，按以下步骤操作，将“悦享工资条”小程序添加到企业的公众号，实现关联
      </div>
      <div>第一步></div>
      <div>
        <el-image :src="require('@/assets/wx/2.png')" :preview-src-list="srcList">
        </el-image>
        <!-- <img src="@/assets/wx/2.png" alt="" /> -->
      </div>
      <div>第二步></div>
      <div>
        <el-image :src="require('@/assets/wx/3.png')" :preview-src-list="srcList">
        </el-image>
        <!-- <img src="@/assets/wx/3.png" alt="" /> -->
      </div>
      <div>第三步></div>
      <div>
        <el-image :src="require('@/assets/wx/4.png')" :preview-src-list="srcList">
        </el-image>
        <!-- <img src="@/assets/wx/4.png" alt="" /> -->
      </div>
      <div>第四步></div>
      <div>
        <el-image :src="require('@/assets/wx/5.jpg')" :preview-src-list="srcList">
        </el-image>
        <!-- <img src="@/assets/wx/5.jpg" alt="" /> -->
      </div>
      <div>第五步></div>
      <div>
        <el-image :src="require('@/assets/wx/6.png')" :preview-src-list="srcList">
        </el-image>
        <!-- <img src="@/assets/wx/6.png" alt="" /> -->
      </div>
      <div class="title">
        3.选择“自定义菜单”，增加菜单项，用于跳转到“悦享工资条”小程序，步骤如下：
      </div>
      <div>第一步></div>
      <div>
        说明：
        点击步骤3，将出现如下窗口，选择“悦享工资条”，点击确定即可，小程序路径将自动变为：pages/home/index
      </div>
      <div>
        <el-image :src="require('@/assets/wx/7.png')" :preview-src-list="srcList">
        </el-image>
        <!-- <img src="@/assets/wx/7.png" alt="" /> -->
      </div>
      <div>第二步></div>
      <div>
        <el-image :src="require('@/assets/wx/8.jpg')" :preview-src-list="srcList">
        </el-image>
        <!-- <img src="@/assets/wx/8.jpg" alt="" /> -->
      </div>
      <div>
        说明：步骤4处，输入备用网页地址：https://www.joyousoa.com/payroll_public
        ，此地址为“悦享工资条”公众号访问地址。
      </div>
      <div class="title">
        4.到此配置完成，进入企业自己的公众号，点击菜单添加的菜单，即可进入到“悦享工资条”小程序。
      </div>
    </div>
  </div>
</template>

<script>
import p1 from '@/assets/wx/1.jpg'
import p2 from '@/assets/wx/2.png'
import p3 from '@/assets/wx/3.png'
import p4 from '@/assets/wx/4.png'
import p5 from '@/assets/wx/5.jpg'
import p6 from '@/assets/wx/6.png'
import p7 from '@/assets/wx/7.png'
import p8 from '@/assets/wx/8.jpg'

export default {
  data () {
    return {
      srcList: [p1, p2, p3, p4, p5, p6, p7, p8],
    }
  },
}
</script>

<style lang="less" scoped>
.main {
  div {
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 10px;
    img {
      width: 90%;
    }
  }
}
.title {
  font-weight: 550;
  font-size: 16px;
  line-height: 55px;
}
.tipinfo {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 550;
  color: #000000;
  line-height: 24px;
  margin-bottom: 21px !important;
}
</style>
